import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
  @Input() numb = 0;
  @Input() subTitle = "";
  @Input() icontitle = "";
  constructor() { }

  ngOnInit(): void {
  }

}
